<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">sell</mat-icon>
        <span>Classificação tributária</span>
    </div>

    <div class="row g-3">
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>CST</mat-label>
                <mat-select formControlName="cstIbsCbs">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (cst of csts; track cst.codigo) {
                    <mat-option [value]="cst.codigo">{{ cst.codigo }} - {{ cst.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Classificação Tributária (cClassTrib)</mat-label>
                <mat-select formControlName="cclassTrib">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (cclass of cclasstribsFiltrados; track cclass.codigo) {
                    <mat-option [value]="cclass.codigo">{{ cclass.codigo }} - {{ cclass.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Indicador de doação</mat-label>
                <mat-select formControlName="indDoacao">
                    <mat-option [value]="null">— Não se aplica —</mat-option>
                    @for (i of indicadoresDoacao; track i.codigo) {
                    <mat-option [value]="i.codigo">{{ i.descricao }}</mat-option>
                    }
                </mat-select>
                <mat-icon
                    matSuffix
                    matTooltip="Informar apenas quando a operação tiver natureza de doação."
                    matTooltipPosition="above">
                    info_outline
                </mat-icon>
            </mat-form-field>
        </div>
    </div>
</div>
</div>
